<script setup>
import {computed, ref} from 'vue';
import ThemeToggler from "@/components/ThemeToggler.vue";
import { updateMe } from '@/helpers/back'
import { useStore } from "@/store/store";
const store = useStore()

const user = computed(() => store.getP('user'))
const v = ref(process.env.VUE_APP_VERSION);
const upd = () => {
  updateMe(store, false).finally()
}
</script>
<template>

    <footer class="footer-section bg-dark text-white">
        <div class="container pt-5 pb-4">

          <div class="row">

            <div class="col-12 col-md-4">
              <div class="footer-logo mb-4">
                <img alt="Vidu" class="img-fluid" src="/images/logo.png" style="height:40px;"/>
              </div>
              <p>
                Видеохостинг для ваших любимых файлов. Без ограничений на объем и время хранения.
                Просмотр при поддержке передового видеоплеера Vidu.
              </p>
              <div class="d-flex flex-row gap-1 align-items-center">
                  <a class="me-3 text-white" href="#"><img alt="Telegram" src="/images/telegram.png" style="height:34px;"/></a>
                  <a class="text-white" href="#"><img alt="YouTube" src="/images/youtube.png" style="height:26px;"/></a>
              </div>
            </div>

            <div class="col-12 col-md-3">
              <h6 class="mb-3">Рекомендации</h6>
              <ul class="list-unstyled">
                <li><a href="#" class="footer-link">Новинки</a></li>
                <li><a href="#" class="footer-link">Популярное</a></li>
                <li><a href="#" class="footer-link">Свежее</a></li>
                <li><a href="#" class="footer-link">Ваше избранное</a></li>
              </ul>
            </div>

            <div class="col-12 col-md-2">
              <h6 class="mb-3">Жанры</h6>
              <ul class="list-unstyled">
                <li><a href="#" class="footer-link">Влоги</a></li>
                <li><a href="#" class="footer-link">DIY</a></li>
                <li><a href="#" class="footer-link">Путешествия</a></li>
                <li><a href="#" class="footer-link">Сериалы</a></li>
              </ul>
            </div>


            <div class="col-12 col-md-3">
              <h6 class="mb-3">Ссылки</h6>

              <ul class="list-unstyled">
                <li><a href="#" class="footer-link">Регистрация</a></li>
                <li><a href="#" class="footer-link">Поиск</a></li>
                <li><a href="#" class="footer-link">Служба поддержки</a></li>
                <li><a href="#" class="footer-link">Для правообладателей</a></li>
                <li><a href="#" class="footer-link">Лицензионное соглашение</a></li>
              </ul>

            </div>
          </div>

            <hr class="my-4 border-secondary" />

            <div class="row">
                <div class="col-12 text-center small d-flex flex-row">
                  <div class="flex-grow-1">© 2025 Все права защищены. <span @click="upd()" role="button">v.{{ v }}</span></div>

                  <div class="ms-auto d-flex flex-row gap-3">
                    <div class="ms-auto">
                      <ThemeToggler />
                    </div>
                  </div>

                </div>
            </div>
        </div>
    </footer>
</template>

<style scoped>
.cards-icons img{
  height: 20px;
  width: auto;
  vertical-align: middle;
}
</style>